const Suitcase = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-Suitcase"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-Suitcase"
      viewBox="0 0 80 60"
      width={_width}
      fill="none"
      {...props}
    >
      <path
        d="M30.2984 63.4793H50.4974C67.3298 63.4793 74.0628 57.7085 74.0628 43.2814V25.9689C74.0628 11.5418 67.3298 5.771 50.4974 5.771H30.2984C13.4659 5.771 6.73291 11.5418 6.73291 25.9689V43.2814C6.73291 57.7085 13.4659 63.4793 30.2984 63.4793Z"
        stroke="#292D32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48.3127 31.4802C47.9761 33.5289 46.5621 35.2601 44.6096 36.2989V42.012C44.6096 44.0029 42.7243 45.6187 40.4014 45.6187C38.0786 45.6187 36.1933 44.0029 36.1933 42.012V36.2989C34.2407 35.2601 32.8268 33.5289 32.4902 31.4802C32.4228 31.1628 32.3892 30.8166 32.3892 30.4703C32.3892 26.0845 37.237 22.6797 42.556 23.8916C45.2492 24.4975 47.4374 26.373 48.1443 28.6814C48.4473 29.6336 48.4811 30.5857 48.3127 31.4802Z"
        stroke="#292D32"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M74.0681 31.4805H48.3145"
        stroke="#292D32"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M32.4866 31.4805H6.73291"
        stroke="#292D32"
        stroke-width="2"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default Suitcase;
